export default {
  title: 'Hayırhah - Online Hayırhahınız!',

  openGraph: {
    type: 'website',
    locale: 'tr_TR',
    site_name: 'hayirhah.com',
    images: [
      {
        url: 'https://hayirhah.com/icons/icon-192.png',
        width: 192,
        height: 192,
        alt: 'Hayırhah Logo',
      },
    ],
  },
  twitter: {
    handle: '@kurantime',
    name: 'Hayırhah',
    site: 'hayirhah.com',
    cardType: 'summary_large_image',
  },
  additionalLinkTags: [
    {
      rel: 'manifest',
      href: '/manifest.json',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '192x192',
      href: '/icons/icon-192.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '512x512',
      href: '/icons/icon-512.png',
    },
    {
      rel: 'apple-touch-startup-image',
      sizes: '512x512',
      href: '/icons/icon-512.png',
    },
    {
      rel: 'apple-touch-startup-image',
      sizes: '192x192',
      href: '/icons/icon-192.png',
    },
  ],
}
